import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import "./HeroMagic.css";

const IG = () => (
  <svg viewBox="0 0 24 24" fill="none"><defs><linearGradient id="hmig" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stopColor="#F9A23A" /><stop offset=".5" stopColor="#E1306C" /><stop offset="1" stopColor="#7638FA" /></linearGradient></defs>
    <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" stroke="url(#hmig)" strokeWidth="2.2" /><circle cx="12" cy="12" r="4.2" stroke="url(#hmig)" strokeWidth="2.2" /><circle cx="17.4" cy="6.6" r="1.3" fill="url(#hmig)" /></svg>
);
const WA = () => (
  <svg viewBox="0 0 24 24"><path fill="#25D366" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Z" /><path fill="#fff" d="M17.3 14.6c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1l-.9 1.1c-.2.2-.3.2-.6.1a7.6 7.6 0 0 1-3.8-3.3c-.3-.5.3-.5.8-1.5.1-.2 0-.4 0-.5l-.9-2.1c-.2-.6-.5-.5-.7-.5h-.6a1.1 1.1 0 0 0-.8.4 3.4 3.4 0 0 0-1 2.5c0 1.5 1.1 2.9 1.2 3.1.2.2 2.1 3.3 5.2 4.6 1.9.8 2.7.9 3.6.7.6-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3Z" /></svg>
);
const WEB = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#3a3480" strokeWidth="2"><circle cx="12" cy="12" r="9.5" /><path d="M2.5 12h19M12 2.5c3 3.2 3 15.8 0 19M12 2.5c-3 3.2-3 15.8 0 19" /></svg>
);
const PH = () => (
  <svg viewBox="0 0 24 24" fill="#1a1a1a"><path d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1A17 17 0 0 1 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1l-2.3 2.2Z" /></svg>
);

const SLOTS = ["10:00", "11:30", "13:00", "14:30", "16:00"];

export default function HeroMagic({ L }) {
  const [filled, setFilled] = useState(1);
  useEffect(() => {
    const id = setInterval(() => setFilled((n) => (n >= SLOTS.length ? 1 : n + 1)), 2500);
    return () => clearInterval(id);
  }, []);
  const bookings = L.heroBookings || ["Анна · Маникюр\n14:30", "Léa · Brow lamination\n11:30", "Mila · Haircut\n16:00"];
  const msgs = L.heroMsgs || ["Можно записаться?", "Есть окно завтра?", "Записаться онлайн", "📞 Входящий звонок"];
  return (
    <div className="hm-scene" data-testid="hero-magic" aria-hidden="true">
      <div className="hm-ring" /><div className="hm-ring r2" />
      <div className="hm-orb" data-testid="hero-orb"><div className="hm-orb-logo">C</div></div>

      <div className="hm-chan ig" data-testid="hero-channel-instagram"><IG /></div>
      <div className="hm-chan wa" data-testid="hero-channel-whatsapp"><WA /></div>
      <div className="hm-chan web" data-testid="hero-channel-web"><WEB /></div>
      <div className="hm-chan ph" data-testid="hero-channel-phone"><PH /></div>

      <div className="hm-msg m-ig">{msgs[0]}</div>
      <div className="hm-msg m-wa">{msgs[1]}</div>
      <div className="hm-msg m-web">{msgs[2]}</div>
      <div className="hm-msg m-ph">{msgs[3]}</div>

      {bookings.map((b, i) => (
        <div key={i} className={`hm-card c${i + 1}`} data-testid="hero-booking-card">
          <span className="sp">✨</span>
          <span className="ic"><CalendarDays className="w-5 h-5" /></span>
          <div><div className="t1">{L.newBooking}</div><div className="t2">{b}</div></div>
        </div>
      ))}

      <div className="hm-cal" data-testid="hero-mini-calendar">
        <div className="hm-cal-h"><span>{L.heroCalTitle || "Завтра"}</span><span>{L.heroCalSub || "календарь"}</span></div>
        <div className="hm-slots">
          {SLOTS.map((s, i) => (
            <div key={s} className={`hm-slot ${i < filled ? "on" : ""}`}>{s}{i < filled && <b>{bookings[i % bookings.length].split("\n")[0].split(" · ")[1] || ""}</b>}</div>
          ))}
        </div>
        <div className="hm-count"><i /> +{filled + 11} {L.heroCalCount || "записей сегодня"}</div>
      </div>
    </div>
  );
}
